import axios from '@/api/tool'

export function zice(type) {
  /*type 1 国高新 2 加计扣除 3专精特新 4国家重点*/
  return axios({
    url: '/meter/addMeterRecord?type=' + type,
    method: "get"
  })
}

// 专精特新>>>>
// 删除项目
export function zuan_delete(id) {
  return axios({
    url: "/zjtxProject/delete/" + id,
    method: "get"
  })
}
// 添加基本信息页面
export function add_essential(data) {
  return axios({
    url: "/zjtxProject/insertProjectInfo",
    method: "post",
    data: data,
  })
}


// 修改基本信息页面
export function update_essential(data) {
  return axios({
    url: "/zjtxProject/updateProjectInfo",
    method: "post",
    data: data,
  })
}

// 查询专精特新立项列表
export function Querylist(data) {
  return axios({
    url: "/zjtxProject/list",
    method: "post",
    data: data,
  })
}

//查询基本信息(回显)
export function queryBaseInfo(id) {
  return axios({
    url: "/zjtxProject/selectProjectInfo/" + id,
    method: "get"
  })
}

//获取最近三年
export function getLastThreeYears() {
  return axios({
    url: "/common/getLastThreeYears",
    method: "get"
  })
}

//保存经济效益
export function saveOperation(data) {
  return axios({
    url: "/zjtxProject/updateStateOperation",
    method: "post",
    data: data
  })
}

//查询经济效益
export function queryOperationInfo(zjtxId) {
  return axios({
    url: "/zjtxProject/selectStateOperation/" + zjtxId,
    method: "get"
  })
}

//保存专业化程度
export function saveDegreeSpecialization(data) {
  return axios({
    url: "/zjtxProject/updateDegreeSpecialization",
    method: "post",
    data: data
  })
}
//回显专业化程度数据
export function getBaseProfessionalInfo(id) {
  return axios({
    url: "/zjtxProject/selectDegreeSpecialization/" + id,
    method: "get"
  })
}

//保存经营管理
export function saveOperatingManagement(data) {
  return axios({
    url: "/zjtxProject/updateOperatingManagement",
    method: "post",
    data: data
  })
}
//回显经营管理
export function getOperatingManagementBaseInfo(id) {
  return axios({
    url: "/zjtxProject/selectOperatingManagement/" + id,
    method: "get"
  })
}

//根据多个类型批量获取文件
export function getMultiFiles(data) {
  return axios({
    url: "/common/file/getMultiFiles",
    method: "post",
    data: data
  })
}
//保存创新能力
export function saveInnovation(data) {
  return axios({
    url: "/zjtxProject/updateInnovationAbility",
    method: "post",
    data: data
  })
}
//回显创新能力
export function getInnovationBaseInfo(id) {
  return axios({
    url: "/zjtxProject/selectInnovationAbility/" + id,
    method: "get"
  })
}

//填写进度
export function getDataGenerated(id) {
  return axios({
    url: "/zjtxProject/selectDataGenerated/" + id,
    method: "get"
  })
}

//生成PDF
export function generatePDF(id) {
  return axios({
    url: "/zjtxProject/generatePDF/" + id,
    method: "get"
  })
}
